module.exports = __webpack_public_path__ + "static/assets/b9aa1cb5d9e4681cc947bcc4ce9bdd4d.jpg";